<template>
  <div v-if="topics.length > 1">
    <LLButton secondary class="w-full relative text-primary-01-400" @click="changeTopicToNext">
      <div class="flex w-full items-center min-w-0">
        <div class="text-base font-bold truncate mr-6">
          {{
            isSelectedTopicLast
              ? $t('conversation_stream_back_to_beginning')
              : $t('conversation_stream_next_topic')
          }}
        </div>
        <svg
          v-if="!isSelectedTopicLast"
          class="absolute right-0 mr-4"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#1F4E6E" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12.1077 6.26739C12.3628 5.94901 12.814 5.9093 13.1155 6.1787L16.7468 9.42352C16.9074 9.56701 17 9.77787 17 10C17 10.2221 16.9074 10.433 16.7468 10.5765L13.1155 13.8213C12.814 14.0907 12.3628 14.051 12.1077 13.7326C11.8526 13.4142 11.8902 12.9377 12.1917 12.6683L14.3328 10.7552H3.71508C3.32015 10.7552 3 10.4171 3 10C3 9.58294 3.32015 9.24484 3.71508 9.24484H14.3328L12.1917 7.33165C11.8902 7.06225 11.8526 6.58577 12.1077 6.26739Z"
            fill="white"
          />
        </svg>
        <svg
          v-if="isSelectedTopicLast"
          class="absolute right-0 mr-4"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="10" cy="10" r="10" fill="#1F4E6E" />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M9.98291 5.19032C10.6139 5.18948 11.2389 5.31329 11.8219 5.55465C12.4049 5.79601 12.9345 6.15015 13.3803 6.59675C13.5988 6.81564 13.9534 6.81596 14.1723 6.59747C14.3912 6.37898 14.3915 6.0244 14.173 5.80551C13.623 5.25452 12.9696 4.81759 12.2503 4.51982C11.5311 4.22208 10.7601 4.06932 9.9817 4.07032L9.98199 4.07032L9.98217 4.63032L9.98142 4.07032L9.9817 4.07032C9.14661 4.07062 8.32101 4.24734 7.55896 4.58891C6.79683 4.93052 6.11548 5.4293 5.55954 6.05258C5.00361 6.67585 4.58563 7.40956 4.33301 8.20562C4.2528 8.45836 4.18984 8.71557 4.14429 8.97549L3.45278 8.034C3.2697 7.78474 2.91921 7.73108 2.66994 7.91417C2.42067 8.09725 2.36702 8.44774 2.5501 8.69701L4.19862 10.9415C4.29071 11.0668 4.43082 11.1483 4.58535 11.1662C4.73989 11.1842 4.89493 11.137 5.01331 11.0361L7.09816 9.25829C7.33349 9.05762 7.36159 8.70416 7.16092 8.46882C6.96024 8.23349 6.60679 8.20539 6.37145 8.40606L5.21356 9.39341C5.25003 9.10612 5.31247 8.82193 5.40054 8.5444C5.60544 7.89872 5.94445 7.30363 6.39536 6.7981C6.84628 6.29257 7.39891 5.88801 8.01706 5.61094C8.63522 5.33387 9.30494 5.19053 9.98234 5.19032L9.98291 5.19032ZM15.1512 8.79577C15.2017 8.78104 15.2544 8.77344 15.3077 8.77344C15.494 8.77316 15.6637 8.86576 15.7664 9.01192L17.4525 11.3021C17.6358 11.5512 17.5826 11.9017 17.3335 12.0851C17.0844 12.2685 16.7339 12.2152 16.5505 11.9661L15.8273 10.9837C15.7199 11.6223 15.5079 12.2427 15.1963 12.8192C14.6089 13.9058 13.6966 14.7818 12.5871 15.3246C11.4775 15.8675 10.2261 16.0501 9.00767 15.847C7.78925 15.6439 6.66472 15.0652 5.79124 14.1918C5.57254 13.9731 5.57253 13.6185 5.79122 13.3998C6.0099 13.1811 6.36448 13.1811 6.58318 13.3998C7.2916 14.1082 8.20364 14.5775 9.19183 14.7422C10.18 14.907 11.195 14.7588 12.0949 14.3186C12.9948 13.8783 13.7346 13.1679 14.2111 12.2866C14.4984 11.7551 14.6812 11.1775 14.7538 10.5846L13.6426 11.5839C13.4126 11.7907 13.0585 11.7719 12.8517 11.5419C12.6449 11.3119 12.6637 10.9578 12.8937 10.751L14.9333 8.91703C14.9466 8.90504 14.9605 8.89376 14.9747 8.88319C15.0269 8.84451 15.0864 8.81455 15.1512 8.79577Z"
            fill="white"
          />
        </svg>
      </div>
    </LLButton>
  </div>
</template>

<script>
import LLButton from '@/components/common/ui-components/LLButton.vue'

export default {
  name: 'StudyNewPageNextTopicButton',
  components: { LLButton },
  props: {
    topics: { type: Array, default: () => [] },
    selectedTopicId: { type: String, default: null }
  },
  computed: {
    isSelectedTopicLast() {
      return this.orderedTopics[this.topics.length - 1]?.id === this.selectedTopicId
    },
    orderedTopics() {
      return [...this.topics].sort((a, b) => a.order - b.order)
    }
  },
  methods: {
    changeTopicToNext() {
      const currentTopicIndex = this.orderedTopics.findIndex((topic) => topic.id === this.selectedTopicId)
      this.isSelectedTopicLast
        ? this.$emit('update:selectedTopicId', this.orderedTopics[0]?.id)
        : this.$emit('update:selectedTopicId', this.orderedTopics[currentTopicIndex + 1]?.id)
    }
  }
}
</script>

<style scoped lang="scss">
.StudyNewPageNextTopicButton {
}
</style>
